export function initVideo() {
  /**
   * Element.requestFullScreen() polyfill
   * @author Chris Ferdinandi
   * @license MIT
   */
  if (!Element.prototype.requestFullscreen) {
    Element.prototype.requestFullscreen = Element.prototype.mozRequestFullscreen || Element.prototype.webkitRequestFullscreen || Element.prototype.msRequestFullscreen;
  }

  // Listen for clicks
  Array.from(document.querySelectorAll('svg.videoPlaceholder')).forEach(img => {
    img.addEventListener('click', (event) => {
      const parent = img.parentNode;

      parent.classList.add('clicked');

      // Get video id
      var videoId = img.dataset.videoId;
      if (!videoId) return;

      // Replace image with YouTube iframe
      parent.innerHTML = '<iframe width="1920" height="1080" src="https://www.youtube.com/embed/' + videoId + '?rel=0&autoplay=1&color=white" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>';

      // Enter fullscreen mode
      const video = parent.childNodes[0];
      video.requestFullscreen();

    }, false);
  });
}